import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom';

export default function PageLinks(props) {
    const pages = props.pages

    function headerButton(label) {
        const link = props => <NavLink to={"/" + label} {...props} />
        return (
          <Button
            component={link}
            key={label}
            sx={{ m: 1, display: 'block', color: "grey.dark" }}
          >
            <Typography
            variant="body1"
            textAlign="center"
            sx={{ "&:hover": { color: "grey.medium" } }} >
              {label}
            </Typography>
          </Button>
        )
      }

    return (
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
        {pages.map((page) => (
            headerButton(page)
        ))}
        </Box>
    )
}